import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/payment';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/** 進入補退費API,取得匯款帳號 */
export function getInfoPayment() {
    return get(`${url}/info`);
};

/** 送出補退費API */
export function submitPayment(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
